import { CellContext } from "@tanstack/react-table";
import type { ViewTableFeatures } from "@design-system/ViewTable/core/table";
import { ORGANIZATION_ROLES_LABELS } from "@common/constants";
import { TeamMemberRow } from "../teamViewConfig";

export const RoleCell = ({
    row,
}: CellContext<ViewTableFeatures, TeamMemberRow, string>) => {
    const member = row.original;
    const role =
        member.type === "member" ? member.role : member.organizationRole;

    if (!role) {
        return <>-</>;
    }

    return <>{ORGANIZATION_ROLES_LABELS[role]}</>;
};
